import React from 'react';
import ReactDOM from 'react-dom/client';
import EversetApp from './EversetApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EversetApp />
  </React.StrictMode>
);